/**
 * Global options.
 */
import {IEnvironment} from '../environments/environment.interface';

export class WebmateOptions {

    public baseApiUri: string;
    public versionedApiUri: string;
    public websocketUri: string;
    public instance?: string;
    public ssoHelperUrl: string;
    public demoenv: boolean;
    public assetBaseUri: string;
    public overrideImageSocketBaseURI?: string;
    public markerIOProject?: string;
    public devtoolsChromiumFrontendUrl?: string;
    public devtoolsWebkitFrontendUrl?: string;
    public seleniumUrl?: string;
    public appiumInspectorFrontendUrl?: string;
    public analyticsPosthogEnabled?: boolean;
    public analyticsPosthogKey?: string;
    public analyticsPosthogUrl?: string;


    constructor(public environment: IEnvironment) {
        let configEnv = environment.useJsConfig ? (window as any)['__env'] as IEnvironment : environment;

        // set baseUrl
        if (!!configEnv.baseUri) {
            this.baseApiUri = configEnv.baseUri;
        } else {
            this.baseApiUri = location.origin + '/api';
        }

        this.baseApiUri = this.baseApiUri.endsWith("/") ? this.baseApiUri.substring(0, this.baseApiUri.length - 1) : this.baseApiUri;
        this.versionedApiUri = this.baseApiUri + '/v1';

        const wssOrWs = this.versionedApiUri.indexOf('https') === -1 ? 'ws' : 'wss';
        this.websocketUri = wssOrWs + this.versionedApiUri.substring(this.versionedApiUri.indexOf(":"));

        if (!!configEnv.ssoHelperUrl) {
            this.ssoHelperUrl = configEnv.ssoHelperUrl;
        } else {
            this.ssoHelperUrl = '/ssohelper';
        }

        // set instance
        if (!!configEnv.instance) {
            this.instance = configEnv.instance;
        }

        this.demoenv = configEnv.demoenv ?? false;
        this.assetBaseUri = configEnv.assetBaseUri;
        this.overrideImageSocketBaseURI = configEnv.overrideImageSocketBaseURI;
        this.markerIOProject = configEnv.markerIOProject;

        if (configEnv.devtoolsChromiumFrontendUrl) {
            this.devtoolsChromiumFrontendUrl = configEnv.devtoolsChromiumFrontendUrl;
        }
        if (configEnv.devtoolsWebkitFrontendUrl) {
            this.devtoolsWebkitFrontendUrl = configEnv.devtoolsWebkitFrontendUrl;
        }

        this.analyticsPosthogEnabled = configEnv.analyticsPosthogEnabled;

        if (!!configEnv.analyticsPosthogUrl) {
            this.analyticsPosthogUrl = configEnv.analyticsPosthogUrl;
        }

        if (!!configEnv.analyticsPosthogKey) {
            this.analyticsPosthogKey = configEnv.analyticsPosthogKey;
        }

        if (!!configEnv.seleniumUrl) {
            this.seleniumUrl = configEnv.seleniumUrl;
        }

        if (!!configEnv.appiumInspectorFrontendUrl) {
            this.appiumInspectorFrontendUrl = configEnv.appiumInspectorFrontendUrl;
        }
    }
}
